__turbopack_context__.v({
  "contentBody": "SlideshowIntroV2-module__UnPF_a__contentBody",
  "contentCard": "SlideshowIntroV2-module__UnPF_a__contentCard",
  "contentLink": "SlideshowIntroV2-module__UnPF_a__contentLink",
  "contentStatic": "SlideshowIntroV2-module__UnPF_a__contentStatic",
  "slide": "SlideshowIntroV2-module__UnPF_a__slide",
  "slideAnimated": "SlideshowIntroV2-module__UnPF_a__slideAnimated",
  "slideImage": "SlideshowIntroV2-module__UnPF_a__slideImage",
  "sliderStage": "SlideshowIntroV2-module__UnPF_a__sliderStage",
  "subtitle": "SlideshowIntroV2-module__UnPF_a__subtitle",
  "title": "SlideshowIntroV2-module__UnPF_a__title",
});
